export default __webpack_public_path__ + "assets/images/icon_instructions.98a3cf9d139b913b772041d42898e6a3.svg";